import React, {useState} from "react";
import { Plus, Trash } from "react-bootstrap-icons";
import { getNotchIcon } from 'services/notches';

import { useLocalStorage, useSessionStorage } from "utils/storage";

const Favorites = ({
    selectedItems = [],
    onItemRemove,
    onSave,
    onCancel
}) => {
    const remove = false;
    const [favorites] = useLocalStorage('favorites', []);

    // initialize with UIDs of already selected items
    const [checkedUids, setCheckedUids] = useState(
        () => new Set(selectedItems.map(item => item.uid))
    );

    const handleToggle = (uid) => {
        setCheckedUids(prev => {
            const next = new Set(prev);
            next.has(uid) ? next.delete(uid) : next.add(uid);
            return next;
        });
    };

    const handleSave = () => {
        const selected = favorites.filter(item => checkedUids.has(item.uid));
        onSave('favorite', selected);
    };

    return (

        <div className="card container-height">

            <div className="card-header form-card-header-paddings no-background no-border">
                <div className="p-2">
                    <h3>Edit Favorites</h3>
                </div>
            </div>

            <div className="card-body form-card-body-paddings overflow-auto">
                <div className="flex-grow-1 overflow-auto">
                    <ul className="list-group list-group-flush w-100">
                        {favorites.map(favoriteItem => (
                            <li
                                key={favoriteItem.uid}
                                className="list-group-item w-100 p-1"
                                style={{ cursor: "pointer", display: 'flex', alignItems: 'stretch' }}
                            >
                                <div
                                    className="d-flex align-items-center"
                                    style={{ marginRight: "5px" }}
                                >
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            id={`checkbox-${favoriteItem.uid}`}
                                            className="form-check-input"
                                            checked={checkedUids.has(favoriteItem.uid)}
                                            onChange={() => handleToggle(favoriteItem.uid)}
                                            style={{ width: '20px', height: '20px' }}
                                        />
                                    </div>
                                </div>

                                <div style={{
                                    width: '4px',
                                    minHeight: '100%',
                                    background: favoriteItem.color,
                                    flexShrink: 0
                                }} />
                                <div style={{ flex: 1, padding: '4px' }}>
                                    <div className="d-flex align-items-center">

                                        {getNotchIcon(favoriteItem.type, {
                                            color: favoriteItem.color ?? null,
                                            size: 18
                                        })}

                                        <span className="flex-grow-1">{favoriteItem.notch}</span>


                                        {remove && (<button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => onItemRemove('favorite', favoriteItem.uid)}
                                        >
                                            <Trash size={16} />
                                        </button>)}
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="card-footer form-card-footer-paddings border-top no-background">
                <div className="d-flex justify-content-between">
                    <button 
                        type="button" 
                        className="btn btn-success" 
                        onClick={handleSave}
                    >
                        Save
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-secondary" 
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Favorites;